import { defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { createLoadableId } from "../records";
/** @public */ export const resourceLoadableProps = {
    // The actual resource we're going to replace
    // The baseString is the value inside here
    variant: T.object({
        variant: T.arrayOf(T.string),
        type: T.arrayOf(T.string)
    }).optional()
};
export const createResourceLoadableId = ({ variant })=>{
    const postfix = typeof variant === "undefined" ? `base` : `${variant.variant.join("-")};${variant.type.join("-")}`;
    return createLoadableId("resource", postfix);
};
export const isResourceLoadable = (loadable)=>{
    if (!loadable) return false;
    if (loadable.typeName !== "loadable") return false;
    return loadable.type === "resource";
};
/** @internal */ export const resourceLoadableMigrations = defineMigrations({});
export const SWResourceLoadableInfo = {
    migrations: resourceLoadableMigrations,
    props: resourceLoadableProps,
    meta: {}
};
